import Vue from 'vue';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
	faCheck,
	faRobot,
	faSync,
	faMoon,
	faSun,
	faAdjust,
	faClock,
	faCaretDown,
	faCircle,
	faCalendar
} from '@fortawesome/free-solid-svg-icons';

library.add(
	faCalendar,
	faSync,
	faCheck,
	faRobot,
	faMoon,
	faSun,
	faAdjust,
	faClock,
	faCaretDown,
	faCircle
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
